var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marketing-landing-page" },
    [
      _c("div", { staticClass: "marketing-landing-page__content" }, [
        _c(
          "div",
          { staticClass: "marketing-landing-page__content--title" },
          [
            _c("h1", { staticClass: "typographies-display-brand-large" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__("Décuplez votre potentiel de croissance")
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "ImgSvg",
              {
                staticClass: "underline",
                attrs: { width: "193px", height: "9px" }
              },
              [_c("Underline")],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "marketing-landing-page__content--informations" },
          [
            _c("p", {
              staticClass: "typographies-paragraph-large-regular",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t.__(
                    "marketing.landing.MarketingLandingPage.informations_line_1",
                    {
                      startStrong:
                        "<span class='typographies-paragraph-large-semibold'>",
                      endStrong: "</span>"
                    }
                  )
                )
              }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "typographies-paragraph-large-regular",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t.__(
                    "marketing.landing.MarketingLandingPage.informations_line_2",
                    {
                      startStrong:
                        "<span class='typographies-paragraph-large-semibold'>",
                      endStrong: "</span>"
                    }
                  )
                )
              }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "typographies-paragraph-large-regular",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t.__(
                    "marketing.landing.MarketingLandingPage.informations_line_3",
                    {
                      startStrong:
                        "<span class='typographies-paragraph-large-semibold'>",
                      endStrong: "</span>"
                    }
                  )
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "marketing-landing-page__content--buttons" },
          [
            !_vm.state.isValidPricing
              ? _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.ask_demo"),
                    type: "secondary",
                    size: "large"
                  },
                  on: {
                    click: function($event) {
                      return _vm.redirectTo(
                        "https://go.sellsy.com/demande-de-rendez-vous",
                        "_blank"
                      )
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "CompassTooltip",
              {
                attrs: {
                  content: _vm.tooltipConfigureButton,
                  disabled: _vm.enableConfigureButton,
                  placement: "bottom-start"
                }
              },
              [
                _c("CompassButton", {
                  ref: "configureButton",
                  attrs: {
                    disabled: !_vm.enableConfigureButton,
                    label: _vm.labelConfigureButton,
                    size: "large"
                  },
                  on: { click: _vm.clickOnConfigureButton }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            visible: _vm.displayCorpVerificationModal,
            title: _vm.$t.__(
              "marketing.landing.MarketingLandingPage.account_checking"
            ),
            "primary-action": _vm.primaryActionCorpVerificationModal,
            "secondary-actions": _vm.secondaryActionsCorpVerificationModal,
            size: "small"
          },
          on: {
            "update:visible": function($event) {
              _vm.displayCorpVerificationModal = $event
            }
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c("span", {
              staticClass: "typographies-paragraph-medium-regular",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t.__(
                    "marketing.landing.MarketingLandingPage.dialog.description",
                    {
                      br: "<br />",
                      startStrong:
                        "<span class='typographies-paragraph-medium-semibold'>",
                      endStrong: "</span>"
                    }
                  )
                )
              }
            })
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("preloader", { attrs: { display: _vm.isLoading } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marketing-landing-page__illustration" }, [
      _c("img", {
        attrs: {
          src:
            "/ressources/logged/img/illustrations/marketing-widget-illustration.png"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }